import { ChangeEvent, useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import UnitsNavBar from "./UnitsNavBar";

const RestoreUnit = () => {
	interface Unit {
		id: number;
		unit: string;
		active: boolean;
	}

	var unitRef = useRef<HTMLSelectElement>(null)

	const [units, setUnits] = useState<Unit[]>([])
	const [isVisible, setIsVisible] = useState(false)
	const [selectedUnit, setSelectedUnit] = useState<Unit>({ id: 0, unit: "", active: false })
	const [unitName,setUnitName] = useState("")
	const [msg, setMsg] = useState("")
	
	const getUnits = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/deletedUnits")
		if (response) {
			const units = await response.json()
			setUnits(units)
		} else {
			setUnits([])
		}

	}

	const restoreUnit = async () => {
		const payload = {id: selectedUnit.id, unit: unitName}
		const response = await fetch(process.env.REACT_APP_API+"/api/unitRestore",{
			method: "POST",
			body: JSON.stringify(payload)
		})
		setMsg(unitName + " restored.")
		if (unitRef && unitRef.current) {
			unitRef.current.value = ""
			setUnitName("")
			setIsVisible(false)
			getUnits()
		}

	}

	const handleSelectChange = async () => {
		if (unitRef && unitRef.current) {
			const id = unitRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/unit?id=" + id);
			const unit = await response.json()
			setSelectedUnit(unit)
			setIsVisible(true)
			setMsg("")
		}
	}
	
	const handleUnitChange = (event: ChangeEvent<HTMLInputElement>) => {
		setUnitName(event.target.value)
	}

	useEffect(() => {
		getUnits()
		if (selectedUnit && selectedUnit.id && selectedUnit.id > 0){
			setUnitName(selectedUnit.unit)
		}
}, [selectedUnit])

	return (
		<div className="resilire">
			<AdminNavBar />
			<UnitsNavBar />
			<label htmlFor="units">Restore Unit</label>
			<select id="units" onChange={handleSelectChange} ref={unitRef}>
				<option value=""></option>
				{units && units.map((unit) => (
					<option value={unit.id} key={unit.id}>{unit.unit}</option>
				))}
			</select>
			{isVisible &&
				(
					<div className="resilire">
						<button name="submit" onClick={restoreUnit}>Restore</button>
					</div>
				)
			}
			{msg && (
				<div className="resilire">
					{msg}
				</div>
			)}
		</div>
	)
};
export default RestoreUnit;
